module.exports = __webpack_public_path__ + "img/brick-blk.6f1b93ff.png";